import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/setup/redux/RootReducer';
import { getSelectedCompany } from '@/modules/auth/helpers/CompanyStorage';
import { getStoredAccessToken } from '@/modules/auth/helpers/TokenStorage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { accessToken, selectedCompany } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const effectiveAccessToken = accessToken || getStoredAccessToken();
  const effectiveSelectedCompany = selectedCompany || getSelectedCompany();

  // console.log('🔒 ProtectedRoute check:', {
  //   hasAccessToken: !!accessToken,
  //   hasSelectedCompany: !!selectedCompany,
  //   selectedCompany: selectedCompany
  // });

  // Check if user is authenticated
  if (!effectiveAccessToken) {
    // console.log('❌ No access token, redirecting to login');
    // Redirect to login page with the return url
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check if user has selected a company
  if (!effectiveSelectedCompany) {
    // console.log('❌ No selected company, redirecting to login');
    // Redirect to login page to select company
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // console.log('✅ ProtectedRoute passed, rendering children');
  return <>{children}</>;
} 